// Translation utility for the admin dashboard
export const translations = {
  en: {
    // Dashboard header
    dashboard: "Dashboard",
    overview: "Overview of your platform's performance",
    refreshDashboard: "Refresh Dashboard",
    refreshing: "Refreshing...",

    // Stats
    totalUsers: "Total Users",
    totalOrders: "Total Orders",
    activeBots: "Active Bots",
    totalSubscriptions: "Total Subscriptions",

    // Portfolio section
    overallPortfolio: "Overall User Portfolio",
    totalPortfolioValue: "Total Portfolio Value",
    change24h: "24h Change",

    // Bot distribution
    botDistribution: "Bot Distribution by Strategy",

    // Portfolio distribution
    portfolioDistribution: "Portfolio Distribution",

    // API status
    apiStatus: "Exchange API Status",
    currentConnection: "Current connection status for all trading exchanges",

    // Recent transactions
    recentTransactions: "Recent Transactions",
    transactionId: "Transaction ID",
    user: "User",
    pair: "Pair",
    type: "Type",
    amount: "Amount",
    price: "Price",
    time: "Time",

    // Time labels
    minutesAgo: "minutes ago",
    hoursAgo: "hours ago",

    // Bot Management
    botManagement: "Bot Management",
    manageBotsDescription: "Manage bot strategies and instances",
    activeBots: "Active Bots",
    botStrategies: "Bot Strategies",
  },

  ja: {
    // Dashboard header
    dashboard: "ダッシュボード",
    overview: "プラットフォームのパフォーマンス概要",
    refreshDashboard: "更新する",
    refreshing: "更新中...",

    // Stats
    totalUsers: "総ユーザー数",
    totalOrders: "総取引数",
    activeBots: "アクティブボット",
    totalSubscriptions: "総利益",

    // Portfolio section
    overallPortfolio: "ユーザーポートフォリオ概要",
    totalPortfolioValue: "ポートフォリオ総額",
    valueInBTC: "BTC換算価値",
    change24h: "24時間変動",

    // Bot distribution
    botDistribution: "戦略別ボット分布",

    // Portfolio distribution
    portfolioDistribution: "ポートフォリオ分布",

    // API status
    apiStatus: "取引所API状態",
    currentConnection: "全取引所の現在の接続状態",

    // Recent transactions
    recentTransactions: "最近の取引",
    transactionId: "取引ID",
    user: "ユーザー",
    pair: "ペア",
    type: "タイプ",
    amount: "数量",
    price: "価格",
    time: "時間",

    // Time labels
    minutesAgo: "分前",
    hoursAgo: "時間前",

    // Bot Management
    botManagement: "ボット管理",
    manageBotsDescription: "ボット戦略とインスタンスの管理",
    activeBots: "アクティブボット",
    botStrategies: "ボット戦略",
  },
};
